import Hotel from "./HotelRoute";

export default Hotel;
